import React, { useState, useRef, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { EmojiPicker, FileAttach, SendMessage } from "asset/icons";
import Picker from "@emoji-mart/react";

const InputSection = ({
    value,
    onChange,
    onSend,
    inputId,
    uploadedFile,
    onFileChange,
    onFileRemove,
    fileInputRef,
}) => {
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const emojiPickerRef = useRef(null);

    const toggleEmojiPicker = () => {
        setShowEmojiPicker((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                setShowEmojiPicker(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div>
            <div className="rounded-lg bg-[#EAECF0] px-3 py-2 relative">
                <input
                    type="text"
                    placeholder="Type here..."
                    className="flex-grow !shadow-none w-full py-2 outline-none pb-3 placeholder-gray-500"
                    value={value}
                    onChange={onChange}
                />

                {uploadedFile && (
                    <div className="flex items-center px-4 py-2 mt-2 bg-white rounded-lg w-72">
                        <span className="mr-2 text-sm font-semibold">{uploadedFile.name}</span>
                        <button onClick={() => onFileRemove(inputId)} className="ml-auto">
                            <AiOutlineClose size={18} className="text-gray-600" />
                        </button>
                    </div>
                )}

                <div className="flex items-center justify-between pt-3">
                    <div className="flex items-center gap-3">
                        <button
                            onClick={(e) => onFileChange(inputId, e)}
                            htmlFor={`file-upload-${inputId}`}
                            className="cursor-pointer"
                        >
                            <FileAttach size={22} />
                        </button>
                        {/* <input
                            // id={`file-upload-${inputId}`}
                            type="file"
                            accept=".pdf,.doc,.docx,.jpg,.png"
                            className="hidden"
                            onClick={(e) => onFileChange(inputId, e)}
                            // onChange={(e) => onFileChange(inputId, e)}
                            // ref={fileInputRef}
                        /> */}
                        <button className="mr-3" onClick={toggleEmojiPicker}>
                            <EmojiPicker size={22} />
                        </button>
                    </div>
                    <button
                        type="button"
                        onClick={() => onSend()}
                        disabled={!value.trim() && !uploadedFile}
                        className={`rounded-full p-2 bg-[#6F00FF] ${
                            !value.trim() && !uploadedFile ? "opacity-30" : "opacity-100"
                        }`}
                    >
                        <SendMessage color="white" />
                    </button>
                </div>
                {showEmojiPicker && (
                    <div ref={emojiPickerRef} className="absolute z-50 bottom-28 left-4">
                        <Picker
                            onEmojiSelect={(emoji) =>
                                onChange({ target: { value: value + emoji.native } })
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default InputSection;
